import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const location = useLocation();

  // Détecter si le lightbox Photos est ouvert
  useEffect(() => {
    const checkLightbox = () => {
      setLightboxOpen(document.body.classList.contains('photos-lightbox-open'));
    };
    const observer = new MutationObserver(checkLightbox);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    checkLightbox();
    return () => observer.disconnect();
  }, []);

  const navItems = [
    { name: 'CINÉMA', path: '/cinema', color: '#CC5555' },
    { name: 'TV/WEB', path: '/tvweb', color: '#00CCCC' },
    { name: 'ALBUMS/EP', path: '/musique', color: '#ec4899' },
    { name: 'STUDIO', path: '/studio', color: '#0b900bff' },
    { name: 'TOURNAGE', path: '/tournage', color: '#CCAA00' },
    { name: 'BIO', path: '/bio', color: '#7DD3FC' },
    { name: 'PHOTOS', path: '/photos', color: '#9966CC' },
    { name: 'ACTUALITÉS', path: '/actualites', color: '#FDD6E0' },
    { name: 'CONTACT', path: '/contact', color: 'rgba(123, 174, 236, 1)' }
  ];

  // Cacher la navigation si le lightbox est ouvert
  if (lightboxOpen) return null;

  return (
    <nav className="fixed top-0 left-0 right-0 z-[10001] bg-black/90 backdrop-blur-sm border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-transparent group-hover:border-cyan-400 transform group-hover:scale-110 transition-all duration-300">
              <img 
                src="/images/profile.jpg" 
                alt="Charles Ludig"
                className="w-full h-full object-cover"
              />
            </div>
            {location.pathname !== "/" && (
              <span className="text-white font-bold text-base sm:text-xl lg:text-sm min-[1200px]:text-xl tracking-wider whitespace-nowrap">CHARLES LUDIG</span>
            )}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden min-[1200px]:flex items-center space-x-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className="px-4 py-2 text-sm font-bold tracking-wide transition-all duration-300 relative group"
                  style={{
                    color: item.color
                  }}
                >
                  {item.name}
                  <span
                    className="absolute bottom-0 left-0 w-full h-0.5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"
                    style={{ 
                      backgroundColor: item.color
                    }}
                  />
                  {isActive && (
                    <span
                      className="absolute bottom-0 left-0 w-full h-0.5"
                      style={{ 
                        backgroundColor: item.color
                      }}
                    />
                  )}
                </Link>
              );
            })}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="min-[1200px]:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="min-[1200px]:hidden absolute top-full right-0 bg-black border border-gray-800 rounded-bl-lg shadow-xl py-2 min-w-[200px] z-[10002]">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className="block px-6 py-2 text-sm font-bold text-right"
                  style={{
                    color: item.color,
                    backgroundColor: isActive ? 'rgba(255,255,255,0.05)' : 'transparent'
                  }}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
